var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.035,
    height: 24.523,
    viewBox: "0 0 29.035 24.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check_1_",
    "data-name": "check (1)",
    d: "M30.862,5.845A1.985,1.985,0,0,1,30.994,8.4L14.577,29.331a1.425,1.425,0,0,1-2.23.105l-9.5-10.275a2.008,2.008,0,0,1-.141-2.438A1.441,1.441,0,0,1,4.979,16.5l7.371,7.617a1.424,1.424,0,0,0,2.2-.132L28.674,5.994a1.424,1.424,0,0,1,2.188-.148Z",
    transform: "translate(-2.36 -5.401)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.6ab03ff6c8d37af115da72a140052c62.svg";
export { ForwardRef as ReactComponent };